// extracted by mini-css-extract-plugin
export default {"previewWrapper":"Preview_previewWrapper__bwEr7","spinner":"Preview_spinner__ppO4l"};